export default __webpack_public_path__ + "static/media/5 - Chapel on Spruce Island.70d492e6.jpeg";